import styles from './Overview.module.scss'
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"

const Overview = () => {

  const data = [
    { campaignName: 'Summer Sale', openRate: '45%', clickThroughRate: '12%', conversionRate: '5%', unsubRate: "1%" },
    { campaignName: 'Summer Sale', openRate: '45%', clickThroughRate: '12%', conversionRate: '5%', unsubRate: "1%" },
    { campaignName: 'Summer Sale', openRate: '45%', clickThroughRate: '12%', conversionRate: '5%', unsubRate: "1%" },
  ]

  const columns = [
    {
      name: 'Campaign Name',
      selector: row => row.campaignName
    },
    {
      name: 'Open Rate',
      selector: row => row.openRate
    },
    {
      name: 'Click-through Rate',
      selector: row => row.clickThroughRate
    },
    {
      name: 'Conversion Rate',
      selector: row => row.conversionRate
    },
    {
      name: 'Unsubscribe Rate',
      selector: row => row.unsubRate
    },
  ]

  return (
    <>
      <div className="fw-medium fs-5">Email Marketing:</div>

      <div className="bg-white p-2">
        <div className={styles['wrapper']}>
          <div className="mb-3">Overview</div>

          <DatatableComponent columns={columns} data={data} type={'gray'} />
        </div>

      </div>
    </>
  )
}

export default Overview